
import Servicios from "../../Components/Servicios/Servicios";
import { serviciosMarketing } from "../../Data/serviciosMarketing";

function Marketing() {
  return (
    <>

      <Servicios
        etiqueta="MARKETING DIGITAL"
        titulo="Presencia digital + Capatación de clientes"
        subtitulo="No se trata solamente de tener una página web. Creamos un sistema que te ayuda a conseguir, organizar y gestionar clientes."
        servicios={serviciosMarketing}
         background="#f0f3f8"
               colorh2 = "#555555"
        colorp = "#777"
      
      />

    </>
  );
}

export default Marketing;

